import { RootState } from '..';
import { CardProductProps } from '../../components/Card/CardProduct';
import { TableProps } from '../../components/Table';
import { formatDateHour } from '../banner/utils';
import { formatBRL } from '../masks';
import { getNestedField } from '../utils';

export const getProduct =
  (state: RootState) =>
  <T extends FlattenKeys<ProductState>>(field: T) =>
    getNestedField(state.product, field);

export const getCardProductList =
  (state): (() => CardProductProps[]) =>
  () =>
    state.product.filtered.price.data.map(
      ({ resume, ean, ...product }, index) => {
        const filials = product?.productfilials as Productfilial[];
        const filial = filials[0];
        const price = filial.prices?.find(
          ({ saleType }) => saleType === 'RETAIL',
        )!;
        const gallery = product?.galleries?.[0] ?? filial?.galleries?.[0];
        const imageSrc = gallery?.imageId
          ? `${process.env.REACT_APP_IMAGE_URL}/${gallery?.imageId}`
          : `/assets/image/image_not_available.png`;
        const imageAlt = gallery?.placeholder ?? 'Imagem não encontrada';

        return {
          title: filial.resume,
          code: filial.code,
          ean,
          imageSrc,
          imageAlt,
          price: price?.regularPrice ?? price?.promotionalPrice ?? 0,
        };
      },
    );

const productGetters = (state: RootState) => ({
  getProduct: getProduct(state),
  getCardProductList: getCardProductList(state),
});

export default productGetters;
